import * as _ from 'lodash';
import { Constants } from 'src/app/data/constants/constants.enum';
import { ListResponse } from 'src/app/data/interfaces/ListResponse';
import { Entities } from 'src/app/data/vo/PricingSummaryVO';
import { environment } from 'src/environments/environment';
import { PaymentGatewayData } from 'src/whiteLabel/mediaCorps/services/misc/misc-data';

const body = document.getElementsByTagName("body")[0];
const html = document.getElementsByTagName("html")[0];

export function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}

export function toString(value: any): string {
    return value !== undefined && value !== null ? `${value}` : '';
}

export function getValueInRange(value: number, max: number, min = 0): number {
    return Math.max(Math.min(value, max), min);
}

export function isString(value: any): value is string {
    return typeof value === 'string';
}

export function isNumber(value: any): value is number {
    return !isNaN(toInteger(value));
}

export function isInteger(value: any): value is number {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

export function isDefined(value: any): boolean {
    return value !== undefined && value !== null;
}

export function padNumber(value: number) {
    if (isNumber(value)) {
        return `0${value}`.slice(-2);
    } else {
        return '';
    }
}

export function regExpEscape(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function hasClassName(element: any, className: string): boolean {
    return (
        element &&
        element.className &&
        element.className.split &&
        element.className.split(/\s+/).indexOf(className) >= 0
    );
}

export function closest(element: HTMLElement, selector): HTMLElement {
    if (!selector) {
        return null;
    }

    return element.closest(selector);
}

export function debounce(delay = 300): MethodDecorator {
    // tslint:disable-next-line: no-any
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        let timeout = null;

        const original = descriptor.value;

        descriptor.value = function (...args) {
            // tslint:disable-next-line: no-unsafe-any
            clearTimeout(timeout);
            // tslint:disable-next-line: no-unsafe-any
            timeout = setTimeout(() => original.apply(this, args), delay);
        };

        return descriptor;
    };
}

export function pruneEmpty(obj) {
    return function prune(current) {
        _.forOwn(current, function (value, key) {
            if (_.isUndefined(value) || _.isNull(value) ||
                (_.isObject(value) && _.isEmpty(prune(value)))) {
                delete current[key];
            }
        });
        if (_.isArray(current)) {
            _.pull(current, undefined);
        }
        return current;
    }(_.cloneDeep(obj));
}

export function applySearchAndPagination(data: any[], params: any): any[] {
    // create new reference
    let results = [...data], searchString = params.searchString, limit = params.limit, offset = params.offset;
    if (results && results.length > 0) {
        if (searchString != null && searchString.length > 0) {
            searchString = searchString.trim().toLowerCase();
            results = results.filter((r: any) => {
                let id: string = r.value;
                return id === searchString || r.label.toLowerCase().includes(searchString);
            });
        }
        let limitNum = +limit, offsetNum = +offset;
        if (results.length > 0 && limitNum > 0 && offsetNum >= 0) {
            if (results.length > offsetNum) {
                if (results.length > (offsetNum + limitNum)) {
                    results = results.slice(offsetNum, offsetNum + limitNum);
                } else {
                    results = results.slice(offsetNum);
                }
            } else {
                results.length = 0;
            }
        }
    }
    return results;
}

export function doFilter(list: Array<any>, params: any): ListResponse {
    let results: any[] = [].concat(list);
    if (params.columnKey) {
        let order = params.sortOrder ? params.sortOrder.toLowerCase() : 'desc';
        results = _.orderBy(results, [params.columnKey], [order]);
    }

    return {
        results: results.slice(params.offset, params.offset + params.limit),
        count: results.length
    }
}

export function createPayload(description: string, customIds: Array<number>, mediaIds: Array<number>, discountCodeId?: string): PaymentGatewayData {
    let entities: Entities[] = [];
    if (description === Constants.CAMPAIGN) {
        entities.push({
            entity_id: customIds[0],
            entity_type: 'CAMPAIGN'
        });
    } else if (description === Constants.CAMPAIGNANDMEDIA) {
        entities.push({
            entity_id: customIds[0],
            entity_type: 'CAMPAIGN'
        });
        mediaIds.forEach((id) => {
            entities.push({
                entity_id: id,
                entity_type: 'MEDIA'
            })
        });
    } else if (description === Constants.MEDIA) {
        customIds.forEach((id) => {
            entities.push({
                entity_id: id,
                entity_type: 'MEDIA'
            })
        });
    }

    return {
        currency_id: environment.currencyId,
        discount_code_id: discountCodeId,
        entities: entities
    };
}

export function downloadExcelFile(blob: Blob, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }, 0);
}

export function addRemoveInvisibleScroll(bAdd: boolean) {
    if (bAdd) {
        body.classList.add("invisible-scrollbar");
        html.classList.add("invisible-scrollbar");
    } else {
        body.classList.remove("invisible-scrollbar");
        html.classList.remove("invisible-scrollbar");
    }

}
